export interface PageMetadata {
  title: string;
  description: string;
}

interface MetadataRoute {
  path?: string;
  name?: unknown;
  params?: Record<string, unknown>;
}

const HOME_METADATA: PageMetadata = {
  title: "Autos seminuevos | GoKey",
  description: "Encuentra autos seminuevos en GoKey. Explora el catálogo, conoce los vehículos disponibles y consulta sus opciones de financiamiento.",
};

const CATALOG_METADATA: PageMetadata = {
  title: "Catálogo de autos seminuevos | GoKey",
  description: "Explora el catálogo de autos seminuevos de GoKey. Filtra los vehículos disponibles y consulta sus características, precio y agencia.",
};

const DETAIL_METADATA: PageMetadata = {
  title: "Detalle de auto seminuevo | GoKey",
  description: "Consulta las características, precio y agencia de este auto seminuevo en GoKey.",
};

export function getPublicPageMetadata(route: MetadataRoute): PageMetadata | null {
  if (route.path === "/home") return { ...HOME_METADATA };
  if (route.path === "/catalogo") return { ...CATALOG_METADATA };
  if (route.name === "car-detail") return { ...DETAIL_METADATA };
  return null;
}

function metadataText(value: unknown): string {
  if (typeof value !== "string" && typeof value !== "number") return "";
  if (typeof value === "number" && !Number.isFinite(value)) return "";
  const text = String(value).replace(/\s+/g, " ").trim();
  return /^(undefined|null|nan)$/i.test(text) ? "" : text;
}

export function buildVehiclePageMetadata(value: unknown): PageMetadata {
  if (!value || typeof value !== "object") return { ...DETAIL_METADATA };
  const vehicle = value as Record<string, unknown>;
  const brand = metadataText(vehicle.brand);
  const model = metadataText(vehicle.model);
  const year = metadataText(vehicle.year);
  const identity = [brand, model, /^\d{4}$/.test(year) ? year : ""]
    .filter(Boolean).join(" ");
  if (!brand && !model) return { ...DETAIL_METADATA };
  return {
    title: `${identity} seminuevo | GoKey`,
    description: `Consulta las características, precio y agencia del ${identity} seminuevo en GoKey.`,
  };
}

export function applyPageMetadata(metadata: PageMetadata): void {
  // Text/attribute writes only: API data is never interpolated as HTML.
  document.title = metadata.title;
  let description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!description) {
    description = document.createElement("meta");
    description.name = "description";
    document.head.appendChild(description);
  }
  description.setAttribute("content", metadata.description);
}

export function applyVehiclePageMetadata(
  currentRoute: MetadataRoute,
  requestedId: string,
  vehicle: unknown
): boolean {
  if (currentRoute.name !== "car-detail" || currentRoute.params?.id !== requestedId) {
    return false;
  }
  applyPageMetadata(buildVehiclePageMetadata(vehicle));
  return true;
}
